<template>
    <div>

      <!-- Collapsible Section Header -->
      <div 
        @click="isExpanded = !isExpanded" 
        class="flex justify-between items-center cursor-pointer mb-3"
      >
        <h3 class="text-lg font-medium">Custom Fields</h3>

        
        <font-awesome-icon :icon="['fas', 'caret-up']" 
            class="text-gray-600 text-xl"
            :rotation="isExpanded ? null : 180"
        />
        
      </div>
  
      <!-- Custom Fields Content -->
      <div v-show="isExpanded" class="space-y-5">
        <div 
            v-for="field in customFields" 
            :key="field.tra_id"
            class="mb-5"
        >
          <div class="text-gray-600 text-xs">{{ field.name }}</div>
          
          <!-- Text/Number Type -->
          <template v-if="field.type == 'Text'">
            <p>{{ getFieldValue(field.tra_id) || '--' }}</p>
          </template>

          <template v-else-if="field.type === 'Number'">
            <p>{{ getFieldValue(field.tra_id) || '--' }}</p>
          </template>
  
          <!-- Date Type -->
          <template v-else-if="field.type === 'Date'">
            <p>
              <date-tooltip 
                v-if="getFieldValue(field.tra_id)" 
                :data="getFieldValue(field.tra_id)" 
              />
              <template v-else>--</template>
            </p>
          </template>
  
          <!-- URL Type -->
          <template v-else-if="field.type === 'URL'">
            <p>
              <a 
                v-if="getFieldValue(field.tra_id)"
                :href="getFieldValue(field.tra_id)"
                class="text-blue-600"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ getFieldValue(field.tra_id) }}
              </a>
              <template v-else>--</template>
            </p>
          </template>
  
          <!-- Address Type -->
          <template v-else-if="field.type === 'Address'">
            <p v-if="getFieldValue(field.tra_id)">
              <template v-if="getFieldValue(field.tra_id).street1">
                {{ getFieldValue(field.tra_id).street1 }}<br>
              </template>
              <template v-if="getFieldValue(field.tra_id).street2">
                {{ getFieldValue(field.tra_id).street2 }}<br>
              </template>
              <template v-if="getFieldValue(field.tra_id).city || getFieldValue(field.tra_id).state">
                {{ [getFieldValue(field.tra_id).city, getFieldValue(field.tra_id).state].filter(Boolean).join(', ') }}
                <template v-if="getFieldValue(field.tra_id).postal_code">
                  {{ getFieldValue(field.tra_id).postal_code }}
                </template>
                <br>
              </template>
              <template v-if="getFieldValue(field.tra_id).country">
                {{ getFieldValue(field.tra_id).country === 'US' ? 'United States' : 'Canada' }}
              </template>
            </p>
            <p v-else>--</p>
          </template>
        </div>
      </div>
    </div>
  </template>
  
  <script>

  export default {
    name: 'CustomFieldsDisplay',
    props: {
      contact: {
        type: Object,
        required: true
      },
      customFields: {
        type: Array,
        default: () => []
      }
    },
  
    data() {
      return {
        isExpanded: true
      }
    },
  
    methods: {
        getFieldValue(traId) {
            let isFieldNumber = this.customFields.find(field => field.tra_id === traId && field.type === 'Number');
            
            if (isFieldNumber) {
                let decimalPlaces = isFieldNumber.show_decimal ? 2 : 0;
                // Check if value exists (not null/undefined) instead of truthy check
                return this.contact.custom_fields[traId] !== null && this.contact.custom_fields[traId] !== undefined
                ? Number(this.contact.custom_fields[traId]).toLocaleString('en-US', {
                    minimumFractionDigits: decimalPlaces,
                    maximumFractionDigits: decimalPlaces
                    })
                : null;
            }

            return this.contact.custom_fields[traId] || null;
        }
    }
  }
  </script>